export default __webpack_public_path__ + "static/media/spaceShipG2.8394c6bb.png";